export default __webpack_public_path__ + "static/vasilis2-523353f1552d3e150aa4eb8587e99b52.png";